import DefaultLayout from "../components/layout/DefaultLayout";

import { Navigation, Pagination, Scrollbar, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";
import LatestProperties from "../components/properties/LatestProperties";
import FeaturedProperty from "../components/properties/FeaturedProperty";
import SearchTool from "../components/ui/SearchTool";

function HomePage() {
  const body = () => {
    return (
      <div>
        <section>
          <div className="container-fluid no-padding">
            <div className="row row-no-padding">
              <SearchTool></SearchTool>
              <div className="col-lg-8">
                <Swiper
                  modules={[Navigation, Pagination, Scrollbar, Autoplay]}
                  spaceBetween={50}
                  slidesPerView={1}
                  navigation={{ enable: false }}
                  pagination={{ clickable: true }}
                  scrollbar={{ draggable: true }}
                  onSlideChange={() => console.log("slide change")}
                  autoplay={{ delay: 5000 }}
                  onSwiper={(swiper) => console.log(swiper)}
                  style={{ height: "100%" }}
                >
                  <SwiperSlide>
                    <img
                      src={"/images/img-slider-1.png"}
                      alt="slider 1"
                      style={{ width: "100%" }}
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src={"/images/img-slider-2.png"}
                      alt="slider 2"
                      style={{ width: "100%" }}
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src={"/images/img-slider-3.png"}
                      alt="slider 3"
                      style={{ width: "100%" }}
                    />
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </section>

        <section className="slice sct-color-1" id="scrollToSection">
          <div className="container">
            <div className="section-title section-title--style-1 text-center mb-5">
              <h3 className="section-title-inner heading-sm strong-600 text-uppercase">
                <span>Ultimas propiedades</span>
              </h3>
              <span className="section-title-delimiter clearfix d-none"></span>
            </div>

            <span className="clearfix"></span>

            <div className="fluid-paragraph fluid-paragraph-sm c-gray-light strong-300 text-center">
              Estas son nuestras ultimas propiedades.
            </div>

            <span className="space-xs-md"></span>

            <LatestProperties></LatestProperties>
          </div>
        </section>

        <section className="slice sct-color-1">
          <div className="container">
            <div className="row align-items-center">
              <FeaturedProperty></FeaturedProperty>
            </div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default HomePage;
